import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=27ff819a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "../assets/styles-new/header.sass?vue&type=style&index=0&id=27ff819a&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ff819a",
  null
  
)

export default component.exports